import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cr-back-button',
  templateUrl: './cr-back-button.component.html',
  styleUrls: ['./cr-back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CrBackButtonComponent implements OnInit, OnChanges {
  private readonly location = inject(Location);

  @Input() routerLink: any[] = [];
  @Input() goBack = false;

  @Input() icon?: string = 'chevron_left';
  @Input() tooltipText?: string;
  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';

  public cssClasses: string[] = [];

  public ngOnInit(): void {
    this.updateCssClasses();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fontSize']) {
      this.updateCssClasses();
    }
  }

  private updateCssClasses(): void {
    this.cssClasses = [`FONT-${this.fontSize}`];
  }

  public onClick(): void {
    if (this.goBack) {
      this.location.back();
    }
  }
}
